import { useQuery } from "@tanstack/react-query";
import DashStatTile from "./v2/DashStatTile";
import { faChartPie } from "@fortawesome/free-solid-svg-icons";
import axios, { AxiosError } from "axios";
import { usePermissionModal } from "contexts/PermissionModalContext";

interface DepartamentoRentavel {
  nome: string;
  margemLucro: number;
  faturamento: number;
}

const fetchDepartamentoRentavel = async (): Promise<DepartamentoRentavel> => {
  const response = await axios.get("/api/dashboardStats/departamento-rentavel");
  return response.data.data;
};

const DepartamentoRentavel = () => {
  const { getQueryRetryHandler } = usePermissionModal();

  const { data, isLoading, error } = useQuery<DepartamentoRentavel, AxiosError>({
    queryKey: ["departamentoRentavel"],
    queryFn: fetchDepartamentoRentavel,
    retry: getQueryRetryHandler({
      queryKey: ["departamentoRentavel"],
      defaultMessage: "Você não possui permissão para visualizar o departamento mais rentável.",
      showModal: false,
    }),
  });

  const isAccessDenied = axios.isAxiosError(error) && error?.response?.status === 403;
  if (isAccessDenied) return null;

  const temDepartamento = data && data.margemLucro > 0;

  return (
    <DashStatTile
      label="Departamento Mais Rentável"
      value={temDepartamento ? data.nome : "Sem dados no período"}
      icon={faChartPie}
      variant="good"
      size="name"
      isLoading={isLoading}
      footnote={temDepartamento ? `Margem de ${data.margemLucro}%` : undefined}
    />
  );
};

export default DepartamentoRentavel;
